import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow_up_white",
  "use": "arrow_up_white-usage",
  "viewBox": "0 0 18 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 10\" id=\"arrow_up_white\"><path fill=\"#FFF\" d=\"M9 2.414l7.293 7.293a1 1 0 0 0 1.414-1.414l-8-8a1 1 0 0 0-1.414 0l-8 8a1 1 0 0 0 1.414 1.414L9 2.414z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol